import { render, staticRenderFns } from "./imgsUpload.vue?vue&type=template&id=bb4baf5a&"
import script from "./imgsUpload.vue?vue&type=script&lang=js&"
export * from "./imgsUpload.vue?vue&type=script&lang=js&"
import style0 from "./imgsUpload.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports